<template>
  <div>
    <ul :style="pagination.totalPages > 1 ? 'margin-bottom: 38px' : ''">
      <local-option
        v-for="(item, index) in options_"
        :key="`${item[valueKey]}_${index}`"
        v-bind="getOptionProps(item)"
      >
        <span v-html="getContent_(item)" />
      </local-option>
    </ul>

    <local-pagination
      v-if="pagination.totalPages > 1"
      fixed
      :total="pagination.total"
      :page="pagination.pageNo"
      :limit="pagination.pageSize"
      :event="pageChange"
      :hide-on-single-page="true"
      layout="prev,slot,next"
      class="position-pagination"
      :has-zero-pagination="hasZeroPagination"
      @click.stop
    >
      <span class="flexCC">
        <el-input
          v-model="curPage"
          style="width: 26px"
          @input="inputAction"
          @blur="jumpPage"
          @keyup.native.stop.enter="jumpPage"
        />
        <span class="height-style_">/</span>
        <span class="height-style">{{ pagination.totalPages }}</span>
      </span>
    </local-pagination>
  </div>
</template>

<script>
import localPagination from '../../Pagination/index.js'
import localOption from './option'
import { Input } from 'element-ui'

export default {
  components: { localPagination, localOption, ElInput: Input },
  props: {
    // 自定义下拉项 props
    getSelectOptionProps: {
      type: Function
    },
    // 分页数据
    pagination: {
      type: Object,
      default() {
        return {}
      }
    },
    // 后端接口页码是否 0 开始
    hasZeroPagination: {
      type: Boolean,
      default: true
    },
    // 下拉框数据
    options: {
      type: Array,
      default() {
        return []
      }
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    // 搜索值
    query: {
      type: String,
      default: ''
    },
    // 是否绑定的是对象
    isBindObject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      curPage: 1
    }
  },
  computed: {
    options_() {
      return this.options.map((v) => {
        const _label = v._label || v.label
        return {
          ...v,
          _label,
          _value: v._value || v.value,
          _selectedLabel:
            v._selectedLabel || v.selectedLabel || v._label || _label
        }
      })
    },
    getContent_() {
      const startTag = `<span class="ag-cell-blue">`
      const endTag = `</span>`
      const value = this.query
      return (item) => {
        const contentText = this.getSelectOptionProps?.(item)?.label ?? item._label
        if (!this.query) {
          return contentText
        }
        const hightLightText = startTag + value + endTag
        const contentEl = value
          ? contentText.replaceAll(value, hightLightText)
          : contentText
        return `<span>${contentEl}</span>`
      }
    },
    // value 绑定的值
    value_() {
      return (item) => {
        return this.isBindObject ? item : item._value
      }
    }
  },
  watch: {
    curPage(nv, ov) {
      // eslint-disable-next-line vue/no-mutating-props
      this.pagination.pageNo = this.hasZeroPagination ? nv - 1 : nv
    },
    'pagination.pageNo'(nv, ov) {
      this.curPage = this.hasZeroPagination ? nv + 1 : nv
    }
  },
  mounted() {},
  methods: {
    getOptionProps(record) {
      return {
        label: record._selectedLabel,
        value: this.value_(record),
        ...this.getSelectOptionProps?.(record)
      }
    },
    inputAction(val) {
      this.$emit('inputAction', val)
    },
    // 跳转分页
    jumpPage() {
      this.$emit('jumpPage')
    },
    // 切换分页数据
    pageChange(obj) {
      this.curPage = this.hasZeroPagination ? obj.page + 1 : obj.page
      this.$emit('pageChange', obj)
    }
  }
}
</script>
